import { createElementBlock as l, openBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function r(a, e) {
  return t(), l("svg", n, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M4.22 7.967a1 1 0 0 0-1.461 0l-.12.13a1 1 0 0 0 0 1.365l6.006 6.425a.5.5 0 0 0 .73 0l8.987-9.611a1 1 0 0 0 0-1.366l-.12-.129a1 1 0 0 0-1.462 0l-7.77 8.31z"
    }, null, -1)
  ])]);
}
const s = { render: r };
export {
  s as default,
  r as render
};
